// extracted by mini-css-extract-plugin
module.exports = {"cancel-button":"fF20QOjBBzd9nhBqd1cj"};